export enum ConsentLocalizationId {
    ClientIntentDescription = "sign-in-consent.client_intent_description",
    ScopesSectionTitle = "sign-in-consent.scopes_section_title",
    AllowButton = "sign-in-consent.allow_button",
    DenyButton = "sign-in-consent.deny_button",
}
